import { useEffect, useState } from "react";
import { listTeamsAccounts } from "../helper/teamsApi";
import { TEAMS_ACCOUNT_EVENT } from "../utils/teams/teamsConnect";
import { teamsSettingsRowState } from "../utils/teams/teamsSettingsModel";

/**
 * Whether the user's Microsoft Teams account is connected (or importing), from GET /teams/accounts.
 * false while loading, on failure and while `disabled`. Reloads on TEAMS_ACCOUNT_EVENT (connect,
 * import progress, disconnect).
 */
export default function useTeamsConnected(disabled = false) {
  const [connected, setConnected] = useState(false);
  useEffect(() => {
    if (disabled) {
      setConnected(false);
      return undefined;
    }
    let alive = true;
    const load = () =>
      listTeamsAccounts()
        .then((res) => {
          const row = teamsSettingsRowState(res);
          if (alive && row) setConnected(!!row.connected);
        })
        .catch(() => {});
    load();
    window.addEventListener(TEAMS_ACCOUNT_EVENT, load);
    return () => {
      alive = false;
      window.removeEventListener(TEAMS_ACCOUNT_EVENT, load);
    };
  }, [disabled]);
  return connected;
}
